import { LoadingContainer } from 'components/loadingContainer'
import { useDeleteDialog } from 'hooks/admin/useDeleteDialog'
import { useDeleteShow } from 'hooks/admin/useShows'
import { useImageById } from 'hooks/user/useImage/useImageById'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ShowWithImages } from 'types/Show'

import { IconButton, IconButtonDelete, IconButtons } from './showCard.style'
import { Container, ImageComponent, ImageContainer, StyledCard } from './showCardWizard.style'

interface Props {
    data: ShowWithImages
    onEdit: (data: any) => void
    onDelete: (id: any) => void
}

export const ShowCardAdmin = ({ data, onEdit }: Props) => {
    const navigate = useNavigate()

    const { data: imageData, isLoading, error } = useImageById(data.cover_image.toString())
    const [isHovered, setIsHovered] = useState(false)
    const { show: showDeleteDialog, DialogComponent: DeleteDialog } = useDeleteDialog()
    const { mutate: deleteShow } = useDeleteShow()

    const handleViewClick = () => {
        navigate(`/musor/${data.show_id}`)
    }

    const handleEditClick = () => {
        onEdit(data.show_id)
    }

    const handleRemoveClick = () => {
        showDeleteDialog(() => deleteShow(data.show_id.toString()))
    }

    const header = (
        <ImageContainer>
            <ImageComponent alt="Card" src={imageData?.image_url} />
            <IconButtons isVisible={isHovered}>
                <IconButton onClick={handleViewClick}>
                    <i className="pi pi-eye" />
                </IconButton>
                <IconButton onClick={handleEditClick}>
                    <i className="pi pi-pen-to-square" />
                </IconButton>
                <IconButtonDelete onClick={handleRemoveClick}>
                    <i className="pi pi-times" />
                </IconButtonDelete>
            </IconButtons>
        </ImageContainer>
    )

    return (
        <Container>
            <LoadingContainer isLoading={isLoading} error={error}>
                <StyledCard
                    title={data.name}
                    header={header}
                    className="w-1rem"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => {
                        setIsHovered(false)
                    }}
                ></StyledCard>
                <DeleteDialog entityLabel={'a műsort'} cascadeWarning={'A törléssel minden hozzá kapcsolódó esemény is törlésre kerül.'} />
            </LoadingContainer>
        </Container>
    )
}
